export default __webpack_public_path__ + "static/media/digital_icon.c9147724.svg";